import { render, staticRenderFns } from "./CouponsOverview.vue?vue&type=template&id=932c3d86"
import script from "./CouponsOverview.vue?vue&type=script&lang=js"
export * from "./CouponsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports